/**
 * The router's `notFoundComponent`, shared by the app plane and the ops
 * plane: one unmatched-route page, not an unstyled default in one plane and
 * a styled one in the other. Reads the global catalogue rather than either
 * plane's own -- the one thing both `createRootRoute` calls can import
 * without crossing the boundary `src/ops/routes/__tests__/composition.test.ts`
 * enforces, and without `src/app/routes/__tests__/paths.test.ts`'s equally
 * strict allowlist on what `routes/index.ts` itself may reach into --
 * `root.tsx` re-exports it from here instead.
 *
 * The way home is `/` in every plane, because each is served from an origin
 * of its own; there is nothing here to decide per plane.
 */

import type { ReactNode } from 'react';

import { t } from '../i18n';

export function NotFound(): ReactNode {
  return (
    <section role="alert" className="mx-auto max-w-prose p-8">
      <h1 className="text-title-md">{t('notFound.title')}</h1>
      <p className="text-muted-foreground text-body-sm mt-2">{t('notFound.body')}</p>
      <a href="/" className="text-body-sm mt-4 inline-block underline">
        {t('notFound.home')}
      </a>
    </section>
  );
}
